import { currentLocale } from '@shared/lib/i18n/i18n';
import { sessionStore } from '@shared/session/store';
import { createApiClient } from './client';
import { readCookie } from './cookies';

export const API_BASE_URL = '/api/v1';
export const CSRF_COOKIE = 'tb_csrf';

type AuthLostHandler = () => void;
type StepUpHandler = () => Promise<boolean>;

let authLostHandler: AuthLostHandler = () => sessionStore.get().clear();
let stepUpHandler: StepUpHandler | null = null;

/** App shell wires navigation (to /login) and the step-up dialog here at boot. */
export function configureApiHandlers(handlers: { onAuthLost?: AuthLostHandler; onStepUpRequired?: StepUpHandler }): void {
  if (handlers.onAuthLost) authLostHandler = handlers.onAuthLost;
  if (handlers.onStepUpRequired) stepUpHandler = handlers.onStepUpRequired;
}

export const api = createApiClient({
  baseUrl: API_BASE_URL,
  getAccessToken: () => sessionStore.get().accessToken,
  getLocale: () => currentLocale(),
  getOrganizationId: () => sessionStore.get().activeOrganizationId,
  onSessionRefreshed: (response) => sessionStore.get().applyLogin(response),
  onAuthLost: () => authLostHandler(),
  onStepUpRequired: () => (stepUpHandler ? stepUpHandler() : Promise.resolve(false)),
  onMfaEnrollmentRequired: () => sessionStore.get().setMfaEnrollmentRequired(true),
  readCsrfToken: () => readCookie(CSRF_COOKIE),
});

export { ApiProblem, isApiProblem } from './problem';
export type { ProblemFieldError } from './problem';
